export default "__VITE_ASSET__CHYpgjNX__"